export const RECEIPTS_COLLECTIONS_REPORT_FORM_LOADING =
  'RECEIPTS_COLLECTIONS_REPORT_FORM_LOADING';
export const RECEIPTS_COLLECTIONS_REPORT_GET_REPORT =
  'RECEIPTS_COLLECTIONS_REPORT_GET_REPORT';
export const RECEIPTS_COLLECTIONS_REPORT_ERROR =
  'RECEIPTS_COLLECTIONS_REPORT_ERROR';
export const RECEIPTS_COLLECTIONS_REPORT_LOADING =
  'RECEIPTS_COLLECTIONS_REPORT_LOADING';
export const RECIEPTS_COLLECTIONS_REPORT_CLEAR_REPORT =
  'RECIEPTS_COLLECTIONS_REPORT_CLEAR_REPORT';
export const RECEIPTS_COLLECTIONS_REPORT_SET_SELECTED_SITES =
  'RECEIPTS_COLLECTIONS_REPORT_SET_SELECTED_SITES';



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/state/report/types.js